var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4254 18.71C23.4596 16.0853 24.8864 13.6019 27.1498 12.2271C25.7219 10.2125 23.3302 8.93514 20.842 8.85823C18.188 8.58302 15.6152 10.4271 14.2628 10.4271C12.8842 10.4271 10.8019 8.88555 8.55972 8.93113C5.63708 9.02441 2.91245 10.666 1.49053 13.1903C-1.56605 18.4184 0.713883 26.1019 3.64183 30.3279C5.10674 32.3972 6.8188 34.7088 9.059 34.6268C11.2512 34.537 12.0699 33.2458 14.716 33.2458C17.3376 33.2458 18.1058 34.6268 20.3914 34.5747C22.7437 34.5369 24.2258 32.4961 25.6393 30.4072C26.6918 28.9327 27.5017 27.3031 28.0391 25.5787C25.2747 24.4236 23.4286 21.6752 23.4254 18.71Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1081 6.07901C20.3907 4.55793 21.0226 2.60283 20.8696 0.628906C18.9101 0.832227 17.1001 1.75742 15.8002 3.22015C14.529 4.64931 13.8675 6.57001 13.9926 8.46848C15.9528 8.48842 17.8798 7.58831 19.1081 6.07901Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppp);
export default __webpack_public_path__ + "static/media/appp.d2a3932ed1fd98adc024e1ee3abfd617.svg";
export { ForwardRef as ReactComponent };